/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon
} from 'react-feather';
import ListCats from './ListCats';

const user = {
  avatar: '/static/images/avatars/avatar_6.png',
  jobTitle: 'Senior Developer',
  name: 'Katarina Smith'
};

const logo = {
  src: '/wp-content/themes/total-child-theme/app/build/static/images/logos/hangeulu_logo.png'
};

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    height: 'calc(100%)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  },
  navLogo: {
    marginTop: 15,
    marginBottom: 15
  }
}));

// eslint-disable-next-line object-curly-newline
// eslint-disable-next-line max-len
// eslint-disable-next-line object-curly-newline
const NavBar = ({ onMobileClose, openMobile, cats, setCats, site, keyword, setKeyword, pressEndter, searchKeyword }) => {
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={2}
      >
        <a className={classes.navLogo} href={site}>
          <img src={site + logo.src} alt="Hangeulu" />
        </a>
        <Typography
          className={classes.name}
          color="textPrimary"
          variant="h5"
        >
          한그루
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          한글 교육 플랫폼
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <ListCats cats={cats} keyword={keyword} setCats={setCats} setKeyword={setKeyword} pressEndter={pressEndter} searchKeyword={searchKeyword} />
      </Box>
      <Box flexGrow={1} />
      <Box
        p={2}
        m={2}
        bgcolor="background.dark"
        style={{ borderRadius: 10 }}
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          한그루 인스타그램
        </Typography>
        <Typography
          align="center"
          variant="body2"
        >
          Let`s go to Hangeulu Instagram!
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={2}
        >
          <Button
            color="primary"
            component="a"
            href="http://instagram.com/korean_hangeulu/"
            target="_blank"
            variant="contained"
          >
            @korean_hangeulu
          </Button>
        </Box>
      </Box>
    </Box>
  );
  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
